import { render, staticRenderFns } from "./AsideBannerV1.vue?vue&type=template&id=6308fc0e&"
import script from "./AsideBannerV1.vue?vue&type=script&lang=js&"
export * from "./AsideBannerV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports